import DraggableModal from "./DraggableModal";
import {useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState} from "recoil";
import {schoolNameState, teacherIdState, teacherNameState} from "../recoil/teacher/teacherIdState";
import {
    classesState,
    fetchClassesSelector,
    fetchTriggerState,
    mainClassState,
    savedClassesState
} from "../recoil/classes/classesState";
import downIcon from "../assets/images/classes/downIcon.svg";
import {useEffect, useState} from "react";
import {cloneDeep} from "lodash";
import {useNavigate} from "react-router-dom";
import {updateMainClass} from "../network/Endpoint";
import {lessonHomeworkState, lessonState} from "../recoil/lesson/lessonState";


const ClassChangeModal = ({ showClassChangeModal, setShowClassChangeModal}) => {
    const [classes, setClasses] = useRecoilState(classesState); // classes atom 업데이트
    const classesLoadable = useRecoilValueLoadable(fetchClassesSelector);
    const [mainClass, setMainClass] = useRecoilState(mainClassState);
    const [teacherName, setTeacherName] = useRecoilState(teacherNameState);
    const [schoolName, setSchoolName] = useRecoilState(schoolNameState);
    const [fetchTrigger, setFetchTrigger] = useRecoilState(fetchTriggerState);
    const [selectedClass, setSelectedClass] = useState(null);
    const teacherId= useRecoilValue(teacherIdState);
    const setLessonInfoId = useSetRecoilState(lessonState);
    const setLessonHomeworkInfoId = useSetRecoilState(lessonHomeworkState);

    const navigate = useNavigate();

    const fetchUpdateMainClass = async() =>{
        try{
            const body = {
                teacherId: teacherId,
                classId: selectedClass.classId
            };

            const res = await updateMainClass(body);

            const statusCode = res.data.status.code;
            const statusMessage = res.data.status.message;
            if (statusCode === 'Success') {
                setFetchTrigger(prev => prev + 1); // ✅ selector 재요청 트리거
                setShowClassChangeModal(false);
            } else {
                alert(`ERROR: 클래스 정보 수정 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.\n${statusMessage}`);
            }
        }catch (error){
            alert('클래스 정보 수정 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.');
        }
    }

    useEffect(() => {
        if (showClassChangeModal === true) {
            setSelectedClass(false);
        }
    }, [showClassChangeModal]);

    useEffect(() => {
        if (teacherId && classesLoadable.state === "hasValue") {
            if(classesLoadable.contents){
                setClasses(cloneDeep(classesLoadable.contents.classes)); // classesState에 데이터 저장
                setTeacherName(classesLoadable.contents?.teacherName || "");
                setSchoolName(classesLoadable.contents?.schoolName || "");

                const mainClassData = classesLoadable.contents.classes.find((item) => item.representativeClass === "Y");
                setMainClass(mainClassData || null);
                setLessonInfoId(null);
                setLessonHomeworkInfoId(null);
            }else{
                alert('클래스를 생성해 주세요');
                navigate("/page/management?page=class");
            }
        }
    }, [classesLoadable, setClasses]);



    return (
        <DraggableModal show={showClassChangeModal} setShow={setShowClassChangeModal} title={'클래스 변경'}  titleStyle={`text-[#50555F] text-[28px] font-[700] mt-[19px] mb-[12px]`} headerHeight={65} rounded={20}>
            <div className="w-[522px] h-[520px] bg-white flex-row justify-center items-center">
                <div className="text-[20px] text-[#50555F] font-[700] mt-8">{schoolName}</div>

                <div
                    className="flex flex-col w-[440px] justify-center items-center mx-auto mt-5  shadow-sm border-[1px] border-[#DADADA] rounded-[20px]">
                    <div
                        className="flex w-full h-[56px] justify-center items-center text-[22px] font-bold text-[#355bdf]"
                    >
                        <div className="text-center">
                            {mainClass && mainClass.name}&nbsp; ({mainClass && mainClass.studentsCount}명)
                        </div>
                    </div>
                    <div className="bg-[#5A85FF] h-[1px] w-[425px]"/>

                    <div
                        className={`w-full origin-top 5 transition-all duration-300 overflow-hidden max-h-[300px]`}
                    >

                        <div className="flex flex-col pl-2 pr-1 mt-2 max-h-[300px] overflow-y-auto gap-[2px]">
                            {classes && classes.map((item, index) => (
                                <div key={index}>
                                    <div

                                        className={`flex flex-row justify-between h-[40px] items-center cursor-pointer rounded-[10px] ${item && selectedClass && item.classId === selectedClass.classId ? 'bg-[#F6F6F6]' : (mainClass && mainClass.classId === item.classId) ? 'bg-[#EEF6FF] text-[#355BDF]' : 'hover:bg-gray-100'} `}
                                        onClick={() => setSelectedClass(item)}
                                    >
                                        <div className="text-[12px] font-normal w-[72px] text-center ">
                                            {item.registerDate}
                                        </div>
                                        <div
                                            className="block px-2 py-2 text-lg max-w-[280px] truncate"
                                        >
                                            {item.name}
                                        </div>
                                        <div
                                            className="text-[12px] font-normal  w-[52px] text-center"
                                        >
                                            {item.studentsCount}명
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div
                    className="flex h-[44px] w-[136px] bg-[#7494FF] text-[20px] text-[#FFF] font-[700] text-center justify-center items-center mx-auto my-8 rounded-[200px] cursor-pointer"
                    onClick={() => fetchUpdateMainClass()}
                >
                    변경하기
                </div>
            </div>
        </DraggableModal>
    )

}

export default ClassChangeModal;